import React from 'react';
import BookCover from '../components/Book';

class Books extends React.Component {
    render(){
        const link = "/books/"+this.props.book.url;
        return (
            <div className="book-list">
                <BookCover book={this.props.book} title={this.props.book.bookTitle} link={link}/>
            </div>
        )
    }
}

export default Books;


// WEBPACK FOOTER //
// ./src/components/Books.js